(() => {
  const cleanText = (value, limit = 240) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, limit);
  const quantityValue = (value) => /^\d{1,7}$/.test(String(value || '')) && Number(value) > 0 ? String(Number(value)) : '';
  const choiceDetails = (choice, product) => {
    const label = cleanText(choice.cardLabel, 100);
    const id = choice.cardVariant || choice.formVariant || product.variant;
    const variant = product.variants.find((item) => String(item.id) === String(id));
    const packQuantity = choice.cardVariant ? label.match(/\d+(?:[.\s\u00a0\u202f]\d{3})*/)?.[0].replace(/[.\s\u00a0\u202f]/g, '') : choice.cardQuantity;
    const quantity = quantityValue(packQuantity || choice.formQuantity || '1');
    // Legacy quantity cards receive the first variant ID from protectBaseVariant.
    const unitQuantityCard = !!choice.cardQuantity && (!choice.cardVariant ||
      (Number(choice.cardQuantity) > 1 && String(choice.cardVariant) === String(product.variants[0]?.id)));
    return { product: product.title, variant: unitQuantityCard || variant?.title === 'Default Title' ? '' : variant?.title || '', pack: label, quantity, productUrl: product.url };
  };
  const parseContext = (search, origin) => {
    const params = new URLSearchParams(search);
    const product = cleanText(params.get('ama_product'));
    if (!product) return null;
    let productUrl = '';
    try {
      const url = new URL(params.get('ama_product_url') || '', origin);
      if (url.origin === origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(url.pathname)) productUrl = url.origin + url.pathname;
    } catch (_) {}
    return { product, variant: cleanText(params.get('ama_variant')), pack: cleanText(params.get('ama_pack'), 100), quantity: quantityValue(params.get('ama_quantity')), productUrl };
  };
  const contextUrl = (href, context, origin, quotePageUrl = '') => {
    const url = new URL(href, origin);
    let expected;
    try { expected = quotePageUrl ? new URL(quotePageUrl, origin) : null; } catch (_) { return null; }
    const matchesQuote = expected
      ? expected.origin === origin && url.pathname.replace(/\/+$/, '') === expected.pathname.replace(/\/+$/, '')
      : /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/demande-de-devis\/?$/i.test(url.pathname);
    if (url.origin !== origin || !matchesQuote) return null;
    [['ama_product', context.product], ['ama_variant', context.variant], ['ama_pack', context.pack], ['ama_quantity', quantityValue(context.quantity)], ['ama_product_url', context.productUrl]].forEach(([key, value]) => {
      if (value) url.searchParams.set(key, cleanText(value, key === 'ama_product_url' ? 600 : 240));
      else url.searchParams.delete(key);
    });
    return url.pathname + url.search + url.hash;
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { cleanText, quantityValue, choiceDetails, parseContext, contextUrl };
  if (typeof document === 'undefined') return;
  const initialize = () => {
    const data = document.querySelector('[data-ama-quote-context]');
    if (!data || data.dataset.initialized) return;
    let config;
    try { config = JSON.parse(data.textContent); } catch (_) { return; }
    data.dataset.initialized = 'true';
    const origin = window.location.origin;
    if (config.product) {
      const scope = document.querySelector('main product-info') || document.querySelector('main');
      if (scope) {
        const getChoice = () => {
          const card = scope.querySelector('.bundle-card.selected[data-qty], .bundle-card.selected[data-vid]');
          const choice = choiceDetails({ cardLabel: card?.querySelector('.bundle-qty')?.textContent, cardVariant: card?.dataset.vid, cardQuantity: card?.dataset.qty, formVariant: scope.querySelector('product-form form [name="id"]')?.value, formQuantity: scope.querySelector('[data-ama-qty-input]')?.value || scope.querySelector('product-form form [name="quantity"]')?.value }, config.product);
          choice.productUrl = new URL(config.product.url, origin).href;
          return choice;
        };
        const updateLink = (event) => {
          const link = event.target.closest('a[href]');
          if (!link || !scope.contains(link)) return;
          const href = contextUrl(link.href, getChoice(), origin, config.quoteUrl);
          if (href) link.setAttribute('href', href);
        };
        scope.addEventListener('pointerdown', updateLink, true);
        scope.addEventListener('click', updateLink, true);
        scope.querySelectorAll('a[href]').forEach((link) => { const href = contextUrl(link.href, getChoice(), origin, config.quoteUrl); if (href) link.setAttribute('href', href); });
      }
    }
    const fields = document.querySelector('[data-ama-quote-fields]');
    if (!fields) return;
    const form = fields.closest('form');
    const context = parseContext(window.location.search, origin);
    if (context) {
      fields.hidden = false;
      fields.querySelector('[name="contact[Reference_produit]"]').value = context.product;
      fields.querySelector('[name="contact[Option_produit]"]').value = [context.variant, context.pack].filter((v, i, values) => v && values.indexOf(v) === i).join(' · ');
      fields.querySelector('[name="contact[Lien_produit]"]').value = context.productUrl;
      const quantity = form.querySelector('#ama-devis-qty');
      if (quantity && !quantity.value && context.quantity) quantity.value = context.quantity;
      const select = form.querySelector('#ama-devis-product');
      if (select && !select.value) {
        const option = document.createElement('option');
        option.value = context.product;
        option.textContent = context.product;
        select.appendChild(option);
        select.value = context.product;
        fields.querySelector('[name="contact[Reference_produit]"]').addEventListener('input', (event) => {
          const selected = select.selectedOptions[0] === option;
          option.value = cleanText(event.target.value);
          option.textContent = cleanText(event.target.value);
          if (selected) select.value = option.value;
        });
      }
    }
    const callback = form.querySelector('#ama-devis-callback');
    const phone = form.querySelector('#ama-devis-phone');
    const phoneLabel = form.querySelector('[for="ama-devis-phone"]');
    const syncCallback = () => {
      if (!phone || !phoneLabel) return;
      phone.required = !!callback?.checked;
      phoneLabel.textContent = callback?.checked ? config.strings.phoneRequired : config.strings.phoneOptional;
    };
    callback?.addEventListener('change', syncCallback);
    syncCallback();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
